import React from 'react';
import * as turf from '@turf/turf';
import { Icon } from 'leaflet';
import { FeatureGroup, Marker } from '@manifesto-tech/react-leaflet';
import defaultIcon from '../../images/marker-default.svg';
import Card from './Card.jsx';
var Markers = function Markers(_ref) {
  var markers = _ref.markers;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(markers).length && Object.keys(markers).map(function (markerType) {
    return /*#__PURE__*/React.createElement(FeatureGroup, {
      key: markerType
    }, markers[markerType].map(function (marker) {
      var coordinates = marker.coordinates,
        properties = marker.properties;
      var type = properties.type,
        image = properties.image,
        name = properties.name,
        description = properties.description,
        linkText = properties.linkText,
        linkUrl = properties.linkUrl,
        iconPath = properties.icon;
      return /*#__PURE__*/React.createElement(React.Fragment, null, coordinates.map(function (position) {
        var pos = turf.getGeom(turf.point(position));
        var icon = new Icon({
          iconUrl: iconPath || defaultIcon,
          iconSize: [40, 40]
        });
        return /*#__PURE__*/React.createElement(Marker, {
          key: turf.flip(pos).coordinates,
          position: turf.flip(pos).coordinates,
          icon: icon
        }, /*#__PURE__*/React.createElement(Card, {
          type: type,
          name: name,
          description: description,
          linkText: linkText,
          linkUrl: linkUrl,
          image: image,
          position: turf.flip(pos).coordinates
        }));
      }));
    }));
  }));
};
export default Markers;